import {Routes} from '@angular/router';
import { Landing } from './landing';
import { GstCalculator } from './gst-calculator';
import { Products } from './products';
import { AdminComponent } from './admin';
import { authGuard } from './guards/auth.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'home', component: Landing },
  { path: 'optimize', canActivate: [authGuard], loadChildren: () => import('./features/optimize/optimize.routes').then(m => m.OPTIMIZE_ROUTES) },
  { path: 'listings', loadComponent: () => import('./app').then(m => m.App) },
  { path: 'inventory', component: Products },
  { path: 'gst-calculator', component: GstCalculator },
  { path: 'admin', component: AdminComponent },
  // Rendered via app.html's own mainView branching (see App component), same as 'admin' and
  // 'inventory' above — this route entry only exists so router.navigate(['/settings']) resolves
  // without a "cannot match route" warning.
  { path: 'settings', component: GstCalculator },
  { path: 'workspace/:listingId', canActivate: [authGuard], loadChildren: () => import('./features/listing-workspace/listing-workspace.routes').then(m => m.LISTING_WORKSPACE_ROUTES) },
];
